import styled, { css } from 'styled-components'
import React from 'react'
import Chip, { ChipProps } from '@material-ui/core/Chip'
import { colors } from '../../styles'

export interface IChip extends ChipProps {
  opacity?: number
  disabled?: boolean
  size?: 'small'
}

export const StyledChip = styled(Chip)<IChip>`
  height: auto;
  margin: 8px 8px 8px 0;
  ${({ opacity }) =>
    opacity &&
    css`
      opacity: ${opacity};
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      background: ${colors.grey10};
      color: ${colors.grey};
    `}
    ${({ size }) =>
      size === 'small' &&
      css`
        height: 18px;

        & > span {
          padding-left: 8px;
          padding-right: 8px;
        }
      `}
` as React.ComponentType<IChip>
